// extracted by mini-css-extract-plugin
export default {"wrapper":"SitesXBTDn_wrapper__RcPc3"};